import { Breadcrumb, HeaderToolbar, Tooltip } from "@xola/ui-kit";
import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { PurchaseRuleLink } from "types";
import { EditTermsTemplateForm } from "../../../components/Agent/TermsTemplate/EditTermsTemplateForm";
import { ColumnLayout } from "../../../components/Layout/ColumnLayout";
import { Loader } from "../../../components/Loader";
import { useResource } from "../../../hooks/useResource";
import { Page } from "../../Page";
import { NoTranslate } from "@/components/Common/NoTranslate";

export const EditTermsTemplatePage = () => {
    const { id } = useParams<{ id?: ID }>();
    const history = useHistory();
    const { data: termsTemplate, isLoading } = useResource<PurchaseRuleLink>(["purchaseRuleLinks", id]);

    const handleTermsTemplateLinkClick = () => {
        history.push("/distribution/termsTemplates");
    };

    return (
        <Page title="Terms Templates">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb className="truncate border-r-0">
                        <Breadcrumb.Item>Distribution</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={handleTermsTemplateLinkClick}>Terms Templates</Breadcrumb.Item>
                        <Tooltip content={<PageTitle name={termsTemplate?.name} />}>
                            <Breadcrumb.Item class>
                                <PageTitle name={termsTemplate?.name} />
                            </Breadcrumb.Item>
                        </Tooltip>
                    </HeaderToolbar.Breadcrumb>
                </HeaderToolbar>

                <ColumnLayout.Fill>
                    {isLoading ? <Loader /> : <EditTermsTemplateForm termsTemplate={termsTemplate} />}
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};

const PageTitle = ({ name }: { name?: string }) => {
    return <NoTranslate if={!!name}>{name ?? "New Template"}</NoTranslate>;
};
